import type { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../providers/AuthProvider";
import path from "../utils/path";
import { HTTPClient } from "../HTTPClient";
import Loader from "../components/Loader/Loader";

export const AuthenticatedRoute = ({ children }: PropsWithChildren) => {
  const { user, isLoading } = useAuth();
  if (user?.idToken) HTTPClient.defaults.headers.common["jwt"] = user.idToken;
  if (isLoading) return <Loader />;
  if (!user)
    return (
      <Navigate to={path.auth.login + "?redirect=" + window.location.pathname} replace={true} />
    );
  if (user?.exp && user.exp < Date.now() / 1000)
    return (
      <Navigate to={path.auth.login + "?redirect=" + window.location.pathname} replace={true} />
    );
  return children;
};
